import { Timestamp } from 'firebase/firestore'
import { Dispatch, SetStateAction } from 'react'
import type { EventShift } from '@Interfaces/Hooks/FormInterface'
import { Address } from './AddressInterface'
import { User } from './UserInterface'
import { Cause } from './CauseInterface'
import { Donation } from './DonationInterface'

export interface Event {
  id?: string
  about: string
  active: boolean
  address: Address
  categories?: string[]
  causes?: string[]
  checkedIn?: unknown[]
  coverPhoto: string
  createdAt: Timestamp
  creator: string
  customUrl?: string
  date: Timestamp
  distanceInM?: number
  endTime: string
  going: number
  hash?: string
  interested?: number
  latLng: { lat?: number; lng?: number }
  lowercaseName: string
  meetingInfo?: string
  meetingURL?: string
  mode: string
  name: string
  newApplications: unknown[]
  openings?: number
  opportunities: unknown[]
  orgId: string
  orgName: string
  orgType: string
  passCode: string
  phone?: string
  repeat: string | boolean
  revenue?: string
  reviewedApplications: unknown[]
  skills?: unknown[]
  startTime: Timestamp
  trendingScore?: number
  type: string
  updatedAt: Timestamp
  volunteersNeeded?: string | null
  waiver?: string
}

export type EventSortBy = 'date' | 'volunteers' | 'status'

export interface CreateEventData {
  id?: string
  about?: string
  categories?: string[]
  date: Timestamp | Date | string | null
  endTime: string
  name: string
  orgId: string
  noOfVolunteers?: string
  volunteersNeeded?: number
  orgName: string
  orgType: string
  passCode?: string
  repeat?: boolean
  startTime: Timestamp | Date | string
  latLng?: { lat: number; lng: number } | null
  address?: Address | null
  shifts?: EventShift[]
  meetingURL?: string
  mode: string
  coverPhoto?: {
    dataUrl: string
  }
  uploadWaiver?: string
  waiver?: {
    url: string
  }
}

export interface EventInterestStatus {
  interested: boolean | null
  going: boolean | null
}

export interface EventAttendee extends User {
  attended?: boolean
}

// Context Props
export interface EventContextProps {
  upcomingEvents: Event[] | []
  setUpcomingEvents: Dispatch<SetStateAction<Event[] | []>>
  pastEvents: Event[] | []
  setPastEvents: Dispatch<SetStateAction<Event[] | []>>
  selectedEvent: Event | null
  setSelectedEvent: Dispatch<SetStateAction<Event | null>>
  causes: Cause[] | []
  eventDonations: Donation[] | []
  setEventDonations: Dispatch<SetStateAction<Donation[] | []>>
}

export const EventContextDefaultValues: EventContextProps = {
  upcomingEvents: [],
  setUpcomingEvents: () => {},
  pastEvents: [],
  setPastEvents: () => {},
  selectedEvent: null,
  setSelectedEvent: () => {},
  causes: [],
  eventDonations: [],
  setEventDonations: () => {},
}
